import React from 'react';
import { Grid, Typography } from '@mui/material';
import { Field } from './Field';
import { FieldProps } from './FieldProps';

export interface FieldListProps {
  title?: string;
  prefix?: string;
  fields: FieldProps[];
  onApply?: () => void;
}

export function FieldList({ title, fields, prefix, onApply }: FieldListProps): React.ReactElement {
  return (
    <>
      {title && <Typography variant="subtitle1">{title}</Typography>}
      <Grid
        spacing={1}
        container
        sx={{
          gap: 'unset !important',
        }}
      >
        {fields.map(({ name: rawName, size = 12, ...rest }) => {
          const name = [prefix, rawName].filter(v => !!v).join('.');
          return (
            <Grid key={name} item xs={size}>
              <Field name={name} onApply={onApply} {...rest} />
            </Grid>
          );
        })}
      </Grid>
    </>
  );
}
